import type { Section } from '../auth/useSession'
import {
  ASSIGNMENTS_PATH,
  CHILL_SLOTS_PATH,
  CONFIG_BM_HOMOLOGATIONS_PATH,
  CONFIG_CHANGES_PATH,
  CONFIG_MACHINE_GROUPS_PATH,
  CONFIG_PLAN_MACHINES_PATH,
  CONFIG_QUALITY_RULES_PATH,
  CONFIG_SETTINGS_PATH,
  CONFIG_SPECIAL_SCHEDULE_PATH,
  CONFIG_STATUS_PATH,
  GROUPS_PATH,
  MEP_MARGIN_HEAT_PATH,
  MEP_SETTINGS_PATH,
  MEP_SHARED_MACHINES_PATH,
  MEP_STAFFING_PATH,
  PESAJE_SETTINGS_PATH,
  RACIONADO_SETTINGS_PATH,
  ROLES_PATH,
  USERS_PATH,
} from './routes'

export type AdminNavEntry = {
  path: string
  label: string
}

export type AdminNavGroup = {
  title: string
  /** The section every screen of the group declares in the API. */
  section: Section
  entries: Array<AdminNavEntry>
}

/**
 * The administration area's sidebar, in order. One group per section, because
 * that is what decides who sees an entry: the API refuses every procedure of a
 * section the role lacks, and this list only keeps the sidebar honest.
 *
 * The same list answers `/admin` (the first entry one can see) and the top
 * bar (whether to show «Administración» at all), so the three cannot disagree.
 */
export const ADMIN_NAV: Array<AdminNavGroup> = [
  {
    title: 'Acceso',
    section: 'admin',
    entries: [
      { path: USERS_PATH, label: 'Usuarios' },
      { path: ROLES_PATH, label: 'Roles y vistas' },
    ],
  },
  {
    title: 'Organización',
    section: 'grupos',
    entries: [
      { path: GROUPS_PATH, label: 'Grupos de estación' },
      { path: ASSIGNMENTS_PATH, label: 'Asignaciones' },
    ],
  },
  {
    title: 'Planificador',
    section: 'configuracion',
    entries: [
      { path: CONFIG_STATUS_PATH, label: 'Estado' },
      { path: CONFIG_MACHINE_GROUPS_PATH, label: 'Máquinas → grupo' },
      { path: CONFIG_PLAN_MACHINES_PATH, label: 'Máquinas del plan' },
      { path: CONFIG_QUALITY_RULES_PATH, label: 'Reglas de calidad' },
      { path: CONFIG_SPECIAL_SCHEDULE_PATH, label: 'Cocción baja' },
      { path: CONFIG_BM_HOMOLOGATIONS_PATH, label: 'Homologación BM' },
      { path: CONFIG_SETTINGS_PATH, label: 'Parámetros' },
      { path: CONFIG_CHANGES_PATH, label: 'Historial' },
    ],
  },
  {
    title: 'Mise en place',
    section: 'configuracion',
    entries: [
      { path: MEP_STAFFING_PATH, label: 'Personas' },
      { path: MEP_SHARED_MACHINES_PATH, label: 'Máquinas que no se comparten' },
      { path: MEP_MARGIN_HEAT_PATH, label: 'Margen y calor' },
      { path: MEP_SETTINGS_PATH, label: 'Parámetros' },
    ],
  },
  {
    title: 'Racionado',
    section: 'configuracion',
    entries: [
      { path: RACIONADO_SETTINGS_PATH, label: 'Alarmas y parámetros' },
      { path: CHILL_SLOTS_PATH, label: 'Huecos de abatir' },
    ],
  },
  {
    title: 'Pesaje',
    section: 'configuracion',
    entries: [
      { path: PESAJE_SETTINGS_PATH, label: 'Ruta y parámetros' },
    ],
  },
]

/** The groups of the sidebar a session can see. */
export const visibleAdminNav = (hasSection: (section: Section) => boolean): Array<AdminNavGroup> =>
  ADMIN_NAV.filter((group) => hasSection(group.section))
